import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const googleDocs = defineConnector({
  identifier: "googleDocs",
  name: "Google Docs",
  tagLine: "Document creation and editing",
  keywords: "gdocs documents word processor writing workspace g suite",
  logo,
  protocol: "http",
  tags: ["featured", "productivity", "documents"],
  defaultUrlPattern: () => "https://docs\\.googleapis\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Connect your Google Docs",
      items: [
        {
          kind: "oauth",
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://accounts.google.com/o/oauth2/v2/auth",
    tokenEndpoint: () => "https://oauth2.googleapis.com/token",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "env",
    authorizationParameters: () => ({
      access_type: "offline",
      prompt: "consent",
    }),
  },
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://docs.googleapis.com/v1/documents/test",
      expectedStatus: 404,
    }),
  },
});
